/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Paste_ButtonInputs */

const en_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const fr_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller`)
};

const de_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const it_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impasto`)
};

const ru_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить`)
};

const es_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta`)
};

const zh_cn2_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴`)
};

const ja_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペースト`)
};

const hi_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट करें`)
};

const pt_pt2_login_offline_paste_button = /** @type {(inputs: Login_Offline_Paste_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar`)
};

/**
* | output |
* | --- |
* | "Paste" |
*
* @param {Login_Offline_Paste_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_paste_button = /** @type {((inputs?: Login_Offline_Paste_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Paste_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_paste_button(inputs)
	if (locale === "de") return de_login_offline_paste_button(inputs)
	if (locale === "it") return it_login_offline_paste_button(inputs)
	if (locale === "ru") return ru_login_offline_paste_button(inputs)
	if (locale === "es") return es_login_offline_paste_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_paste_button(inputs)
	if (locale === "ja") return ja_login_offline_paste_button(inputs)
	if (locale === "hi") return hi_login_offline_paste_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_paste_button(inputs)
	return en_login_offline_paste_button(inputs)
});